export enum RoleType {
  UnderWriter = 'Underwriter',
  RegionalSalesManager = 'RegionalSalesManager',
  Accountant = 'Accountant',
  Other = 'Other'
}